import { Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { MatChipListboxChange } from '@angular/material/chips';
import { EnpsComponent } from '@common/components/base/enps-component';
import { ViewStateFilterStates } from '@common/enums/viewstate-filter-states';
import { ViewStateFilterVisibility } from '@common/enums/viewstate-filter-visibility';
import { ViewStateLayouts } from '@common/enums/viewstate-layouts';
import { ViewStateTypes } from '@common/enums/viewstate-types';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { LayoutState } from '@common/services/layout-state';
import { VisualStateService } from '@common/services/visual-state-service';
import { Store } from '@ngrx/store';
import { ViewStateActions } from '@src/suite/common/store/navigation/actions/viewstate.actions';
import { AppService } from '@suite/app.service';

@Component({
    selector: 'st-filter-planning-views',
    templateUrl: './filter-planning-views.html',
    encapsulation: ViewEncapsulation.None,
})
export class FilterPlanningViewsComponent extends EnpsComponent {
    private store = inject(Store);
    public viewStateTypes = ViewStateTypes;
    public viewStateFilterStates = ViewStateFilterStates;
    public viewStateLayouts = ViewStateLayouts;
    public viewStateFilterVisibility = ViewStateFilterVisibility;

    public filterViewStateTypes: Array<{ ViewStateType: number; ViewStateTypeName: string }> = [
        { ViewStateType: -1, ViewStateTypeName: 'All' },
        { ViewStateType: ViewStateTypes.TOPIC, ViewStateTypeName: 'Topic' },
        { ViewStateType: ViewStateTypes.ASSIGNMENT, ViewStateTypeName: 'Assignment' },
        { ViewStateType: ViewStateTypes.SCRIPT, ViewStateTypeName: 'Script' },
        { ViewStateType: ViewStateTypes.SEARCH, ViewStateTypeName: 'Search' },
    ];

    public group: string = 'all';

    public all: string = 'all';
    public global: string = 'global';
    public personal: string = 'personal';

    constructor(
        public appService: AppService,
        public layoutState: LayoutState,
        public languageSettings: LanguageSettings,
        public globalTablesService: GlobalTablesService,
        public visualStateService: VisualStateService
    ) {
        super();

        this.teams = this.globalTablesService.getListItemsForTeamLocations();
    }

    public teams = [];

    creators = signal<Array<string>>([]);

    public async onTeamChange(event: MatChipListboxChange) {
        this.group = event.value;
        await this.layoutState.loadViewStateRecords(this.group, this.creators());
    }

    public async onCreatorChange(value: string[]) {
        this.creators.set(value);
        await this.layoutState.loadViewStateRecords(this.group, this.creators());
    }

    public toggle() {
        this.store.dispatch(ViewStateActions.togglePlanningViewsFilterState());
    }
}
